'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { ordersOperations, ordersSelectors } from '@/state/domains/orders';
import { attemptsOperations } from '@/state/domains/attempts';
import { locationsSelectors } from '@/state/domains/locations';
import { DEFAULT_OPTS } from '@/state/domains/attempts/utils';

import { RecipientSection } from '../';

import c from '@/views/styles/common.scss';
import s from './styles.scss';
import l from '../styles.scss';

class AttemptForm extends React.Component {

	constructor() {

		super();

		this.state = {
			setting: {
				options: DEFAULT_OPTS.map(o => ({ label: o, value: o })),
				value: []
			}
		};

		[
			'handleSelectChange',
			'handleApplyAttemptClick'
		].forEach(fn => { this[fn] = this[fn].bind(this) });
	}

	handleSelectChange(values) {

		const { setting } = this.state;
		setting.value = values;
		this.setState({ setting });
	}

	handleApplyAttemptClick() {

		const {
			postAttempt,
			username,
			job,
			date,
			location,
			setActionMode
		} = this.props;

		const { setting } = this.state;

		const jobId = job._id;
		const locationId = location._id;
		const details = setting.value.map(o => o.value);

		const geolocation = window.navigator.geolocation;
		
		geolocation.getCurrentPosition(
			pos => {

				const { coords } = pos;
				const { latitude, longitude } = coords;

				const geo = [ latitude, longitude ];

				postAttempt({
					username,
					date,
					jobId,
					locationId,
					details,
					geo
				}).then(() => {

					const { setting } = this.state;
					setting.value = [];
					this.setState({ setting });
					setActionMode('select');
				});

			},
			err => {
				postAttempt({
					username,
					date,
					jobId,
					locationId,
					details,
					geo: []
				}).then(() => {

					const { setting } = this.state;
					setting.value = [];
					this.setState({ setting });
					setActionMode('select');
				});
			},
			{
				timeout: 5000,
				maximumAge: 0,
				enableHighAccuracy: true
			}
		);
	}

	render() {

		const { job, setActionMode } = this.props;
		const { setting } = this.state;

		const customStyles = {
			container: () => ({
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
			}),
			menu: () => ({
				marginTop: '8px',
				marginBottom: '8px',
				textAlign: 'center',
			}),
		};

		return (
			<>
				<div className={ l.formHeader }>
					<span className={ l.title }>Attempt</span>
					<span className={ l.cancel } onClick={ () => setActionMode('select') } >
						<FontAwesomeIcon icon='times' color='#fff'/>
					</span>
				</div>
				<div className={ l.column }>
					<RecipientSection job={ job } />
					<div className={ l.row }>
						<div className={ s.formCont }>
							<Creatable
								isMulti
								placeholder='Attempt details'
								onChange={ this.handleSelectChange }
								options={ setting.options }
								value={ setting.value }
								closeOnSelect={ false }
								maxMenuHeight={ 148 }
								menuIsOpen={ true }
								styles={ customStyles }
							/>
						</div>
					</div>
					<div className={ l.row }>
						<button className={ c.apply } onClick={ this.handleApplyAttemptClick }>Apply</button>
					</div>
				</div>
			</>
		);
	}
}

export default connect(
	(state, props) => ({
		date: appSelectors.getPageDate(state, props),
		jobId: appSelectors.getPageJobId(state, props),
		username: usersSelectors.getUsername(state, props),
		location: locationsSelectors.getPageLocation(state, props),
	}),
	{
		setActionMode: appOperations.setActionMode,
		postAttempt: attemptsOperations.postAttempt,
		fetchAttempts: attemptsOperations.fetchAttempts,
	}
)(AttemptForm);
